import { TemplateType } from '../../consts/forms-types';
import Controls from '../../pages/templates/Controls';
import { formatDate } from '../../utils/date';
import Tooltip from '../tooltip';
import { ReactComponent as FolderIcon } from '../../shared/icons/folder-icon.svg';
import FolderControls from '../../pages/templates/FolderControls';
import ClauseFolderControls from '../../pages/clauses/components/ClauseFolderControls';
import styles from './styles.module.scss';

export interface TemplateData {
  name: string;
  status: string;
  updatedAt: string;
  template: {
    id: string;
    fromOrganization: boolean | null;
    organizationName?: string | null;
    isFolder?: boolean;
  };
}

interface MobileTemplateItemProps {
  template: TemplateData;
  isAdmin: boolean;
  canEdit: boolean;
  canManageTemplates?: boolean;
  teamId: string;
  selectedTemplate: any;
  templateIsUpdated: () => void;
  onClick?: () => void;
  context?: 'templates' | 'clauses';
  refetchFolders?: () => void;
}

export const MobileTemplateItem: React.FC<MobileTemplateItemProps> = ({
  template,
  isAdmin,
  canEdit,
  canManageTemplates = false,
  teamId,
  templateIsUpdated,
  selectedTemplate,
  onClick,
  context = 'templates',
  refetchFolders,
}) => {
  return (
    <div className={styles.dealItem} onClick={onClick}>
      <div className={styles.dealItem__header}>
        <div className={styles.dealItem__title}>
          {template.template.isFolder && (
            <FolderIcon
              style={{ marginRight: '8px', width: '16px', height: '16px', fill: '#006c90', verticalAlign: 'middle' }}
            />
          )}
          {template.name}
        </div>

        <div
          onClick={(evt) => {
            evt.stopPropagation();
          }}
          className={styles.actionsTableColumn}
        >
          {template.template.isFolder ? (
            // Folder actions
            context === 'clauses' ? (
              <ClauseFolderControls
                folderId={template.template.id}
                folderName={template.name}
                editPermission={isAdmin || canManageTemplates}
                teamId={teamId}
                onSuccess={() => {
                  templateIsUpdated();
                  refetchFolders?.();
                }}
              />
            ) : (
              <FolderControls
                folderId={template.template.id}
                folderName={template.name}
                editPermission={isAdmin || canManageTemplates}
                teamId={teamId}
                onSuccess={() => {
                  templateIsUpdated();
                  refetchFolders?.();
                }}
              />
            )
          ) : !template.template.fromOrganization ? (
            <Controls
              status={template.status || ''}
              editPermission={isAdmin || canManageTemplates}
              selectedTemplateData={selectedTemplate}
              teamId={teamId}
              onSuccess={templateIsUpdated}
              templateType={TemplateType.DOCUMENT}
            />
          ) : (
            <div className={styles.templatesTooltipContainer}>
              <Tooltip placement="bottom" testId="organization-template-tooltip">
                This Template is available due to your active membership in {template.template.organizationName}, it
                cannot be edited.
              </Tooltip>
            </div>
          )}
        </div>
      </div>
      <div className={styles.dealItem__footer}>
        <div className={styles.dealItem__creator}>{template.status}</div>
        <div className={styles.dealItem__updatedAt}>{formatDate(template.updatedAt)}</div>
      </div>
    </div>
  );
};
